var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ui-input',{attrs:{"value":_vm.value,"required":_vm.required,"label":"CEP","placeholder":"CEP","mask":"#####-###"},on:{"input":_vm.validateCep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }